export const percentage = (number: number, total: number) =>
  Math.round(number * 100) / total

export const percentChanged = (amount: number, previousAmount: number) =>
  Math.round(((amount - previousAmount) / Math.abs(previousAmount)) * 100)
